import { defineTextStyles } from '@pandacss/dev';
import { typographyMetrics } from './typography-tokens';

export const textStyles = defineTextStyles({
  heading: {
    hero: { value: { ...typographyMetrics.headingHero } },
    page: { value: { ...typographyMetrics.headingPage } },
    modal: { value: { ...typographyMetrics.headingModal } },
    section: { value: { ...typographyMetrics.headingSection } },
    item: { value: { ...typographyMetrics.headingItem } },
  },
  body: {
    lg: { value: { ...typographyMetrics.bodyLarge } },
    DEFAULT: { value: { ...typographyMetrics.bodyDefault } },
    strong: { value: { ...typographyMetrics.bodyStrong } },
  },
  label: {
    DEFAULT: { value: { ...typographyMetrics.labelDefault } },
  },
  meta: {
    DEFAULT: { value: { ...typographyMetrics.metaDefault } },
  },
  productMono: {
    DEFAULT: { value: { ...typographyMetrics.monoDefault } },
    sm: { value: { ...typographyMetrics.monoSmall } },
  },
});
